import Parser from 'html-react-parser';

export const getCollectionsList = (log) => {
  const itemsOut = [];

  log.diff.forEach((c) => {
    itemsOut.push(`<a href="/collections/${c.uuid}/" target="_blank">${c.name}</a>`);
  });

  return Parser(itemsOut.join(', '));
};

export const getTermsList = (log, url = false) => {
  const itemsOut = [];

  log.diff.forEach((t) => {
    if (url) {
      itemsOut.push(`<a href="${url}${t.uuid}/" target="_blank">${t.name}</a>`);
    } else {
      itemsOut.push(`<span>${t.name}</span>`);
    }
  });

  return Parser(itemsOut.join(', '));
};
